var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs2, _mask, _g, _path43, _path44, _defs3, _g2, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _defs4, _g3, _path59, _defs5, _g4, _path60, _defs6, _g5, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningInfoGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 205 204",
    style: {
      enableBackground: "new 0 0 205 204"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000163063398013516721990000013440820227338991779_);}\n\t.st1{fill:#FDC849;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#E27756;}\n\t.st4{fill:#FD521B;}\n\t.st5{fill:#FFC849;}\n\t.st6{fill:#FFAB00;}\n\t.st7{fill:#5774CD;}\n\t.st8{fill:#FFB6C8;}\n\t.st9{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st10{mask:url(#mask9_262_14984_00000111899603717126353900000005816642142716618624_);}\n\t.st11{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter_00000078729831394175291030000005407410905326671015_);}\n\t.st12{mask:url(#mask10_262_14984_00000110428264738177317060000006806328223622678923_);}\n\t.st13{fill:#D7E5FF;}\n\t.st14{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter_00000171710619055226012670000000519770646819009715_);}\n\t.st15{mask:url(#mask15_262_14984_00000092417709765313343850000001085004822384630681_);}\n\t.st16{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter_00000165919545989184935910000011267131206655326885_);}\n\t.st17{mask:url(#mask16_262_14984_00000010992274775506275570000013535375693062255016_);}\n\t.st18{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter_00000088836073461362033660000013071490764371968933_);}\n\t.st19{mask:url(#mask17_262_14984_00000171000764445846093630000001215532870712825761_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 7,
    width: 142,
    height: 126
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152229559564449097940000011418636559374869648_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152229559564449097940000011418636559374869648_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.8,12.9c4.6-7.9,15.9-7.9,20.5,0l29.6,51.2l29.6,51.2c4.6,7.9-1.1,17.7-10.2,17.7H11.8 c-9.1,0-14.8-9.8-10.2-17.7l29.6-51.2L60.8,12.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.9,107c0-4.4,3.5-7.9,8.2-7.9c4.6,0,8,3.4,8,7.9c0,4.7-3.5,8.1-8,8.1C66.7,115.1,62.9,111.7,62.9,107z  M64.5,93.8L63.7,40h14.6l-1,53.8H64.5z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M118.4,145.1l-4.3,18.1l-6.4,0.2l-3.7-3.6l3.7-19.3L118.4,145.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M138.8,145.1l0.2,17l6.3,2.7l4.4-2.8l0.5-19.5L138.8,145.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.9,150.6l11.2-2.5l0.1-5.7l-11.4,2.6L138.9,150.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.9,145.2l10.6,3.6l0.9-3.6l-10.6-4.5L106.9,145.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M106,76.9c0,0-2.5,12-8.1,17.9c-0.4,0.4-0.4,1.1-0.2,1.6c0.3,0.5,0.8,0.7,1.2,0.4c1.3-0.8,3.8-3.4,6.4-6.6 c4.5-5.6,2.8-14.5,2.8-14.5L106,76.9L106,76.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M101,83.4c0,0-1.8,4.1-10.9,6.5c-0.5,0.1-0.8,0.7-0.8,1.2c0,0.5,0.4,0.9,0.8,0.8c1.4-0.1,4.4-0.5,7.8-2.1 c3.6-1.7,7.2-6.3,7.2-6.3L101,83.4L101,83.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.8,87.8c0,0-2.8,2.3-10.3,3.9c-0.5,0.1-0.9,0.6-0.9,1.2c0,0.5,0.3,1,0.7,1c1.4,0.1,4.5,0.1,8.1-1.2 c3.8-1.4,4.7-2.7,4.7-2.7L98.8,87.8L98.8,87.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.5,82.5c0,0-8.5,8.6-16.4,10.3c-0.5,0.1-1,0.6-1,1.2c0,0.6,0.3,1,0.8,1c1.5,0.1,5.5-0.5,9.3-1.7 c6.8-2.1,9.8-10.7,9.8-10.7L104.5,82.5L104.5,82.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M106,83.6c0,0-8.5,8.6-16.5,10.3c-0.5,0.1-1,0.6-1,1.2c0,0.6,0.3,1,0.8,1c1.5,0.1,5-0.7,8.9-1.8 c6.8-2.1,10.2-10.5,10.2-10.5L106,83.6L106,83.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90,92.1c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.1 c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.4,0.1c1.5-0.1,4.3-0.6,6.7-1.6c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.2-0.1,0.2 C94.4,91.4,91.6,92,90,92.1C90,92.1,90,92.1,90,92.1L90,92.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9,93.9c-0.5,0-0.8-0.1-1.1-0.2c-0.2-0.1-0.3-0.3-0.4-0.5c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.2,0.1 c0,0.1,0.1,0.2,0.2,0.3c1.3,0.7,6.6-0.9,9.2-1.9c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.2-0.1,0.2C95.6,92.5,91.2,93.9,88.9,93.9L88.9,93.9z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7,95.4c-0.1,0-0.2-0.1-0.2-0.1c0-0.1,0.1-0.2,0.1-0.2C90,95,95.1,94,97.6,93c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.2-0.1,0.2 C95.1,94.3,90.1,95.3,88.7,95.4L88.7,95.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100,90.7c-0.1,0-0.1,0-0.2-0.1c0-0.1,0-0.2,0.1-0.2c0,0,3.6-0.8,5-4.2c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0.1,0.2 C103.8,89.9,100,90.7,100,90.7C100,90.7,100,90.7,100,90.7L100,90.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3,94.5c-0.1,0-0.1,0-0.1-0.1c0-0.1,0-0.2,0.1-0.2l3.4-1.7c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.2-0.1,0.2L98.3,94.5 C98.3,94.5,98.3,94.5,98.3,94.5L98.3,94.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M187.6,19.9c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.3,0.1-0.4l4.3-3.3c0.1-0.1,0.3-0.1,0.4,0.1 c0.1,0.1,0.1,0.3-0.1,0.4l-4.3,3.3C187.8,19.9,187.7,19.9,187.6,19.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M189.4,23.4c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.2,0-0.3,0.2-0.4l5.1-1.9c0.2-0.1,0.3,0,0.4,0.2 c0.1,0.2,0,0.3-0.2,0.4l-5.1,1.9C189.5,23.3,189.4,23.4,189.4,23.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M195.2,27l-5.4,0c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3l5.4,0c0.2,0,0.3,0.1,0.3,0.3 C195.5,26.8,195.4,27,195.2,27L195.2,27z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M163.9,38.4l-1.9,0.5c-0.4,0.1-0.6,0.5-0.5,0.9l2.8,10.3c0.1,0.4,0.5,0.6,0.9,0.5l1.9-0.5 c0.4-0.1,0.6-0.5,0.5-0.9l-2.8-10.3C164.7,38.5,164.3,38.3,163.9,38.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M164,38.3l-0.5,0.1c-0.3,0.1-0.5,0.4-0.4,0.7l2.8,10.6c0.1,0.3,0.4,0.5,0.7,0.4l0.5-0.1c0.3-0.1,0.5-0.4,0.4-0.7l-2.8-10.6 C164.7,38.5,164.4,38.3,164,38.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M155.6,35.7c-0.5-1.8,0.5-3.7,2.3-4.2c1.8-0.5,3.6,0.6,4.1,2.5c0.5,1.8-0.5,3.7-2.3,4.2 C157.9,38.7,156.1,37.5,155.6,35.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M178.4,37.1c-0.8,0-1.7-0.5-2.5-1.5c-1-1.2-1.8-2.8-2.3-4.7c-1.1-3.9-0.4-7.4,1.4-7.9c0.9-0.2,1.9,0.3,2.9,1.5 c1,1.2,1.8,2.8,2.3,4.7c1.1,3.9,0.4,7.4-1.4,7.9C178.6,37.1,178.5,37.1,178.4,37.1z M175.5,23.2c-0.1,0-0.2,0-0.4,0 c-1.6,0.4-2.2,3.8-1.2,7.5c0.5,1.8,1.3,3.4,2.2,4.6c0.9,1.1,1.8,1.6,2.6,1.4c1.6-0.4,2.2-3.8,1.2-7.5c-0.5-1.8-1.3-3.4-2.2-4.6 C176.9,23.7,176.1,23.2,175.5,23.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M159.1,29l10-2.7L172,37l-10,2.7c-1.8,0.5-3.8-1.5-4.6-4.5C156.5,32.3,157.3,29.5,159.1,29L159.1,29z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M169.1,26.3l9.1-8.3l5.8,21.7L172,37c-1.8,0.5-3.8-1.5-4.6-4.5C166.6,29.6,167.4,26.8,169.1,26.3L169.1,26.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M184,39.7c2.7-0.7,3.6-6.2,2-12.2s-5.1-10.3-7.8-9.5c-2.7,0.7-3.6,6.2-2,12.2C177.8,36.2,181.3,40.5,184,39.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M183.7,38.5c2.4-0.6,3.2-5.5,1.8-10.8c-1.4-5.3-4.6-9.1-7-8.5c-2.4,0.6-3.2,5.5-1.8,10.8 C178.1,35.4,181.2,39.2,183.7,38.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M176.8,26.7c-0.3,0.1-0.5,0.2-0.7,0.3c0.1,1,0.3,2,0.6,3.1c0.3,1,0.6,2,1,2.9c0.3,0,0.5,0,0.8-0.1c1.7-0.5,2.7-2.2,2.3-3.9 C180.3,27.3,178.5,26.3,176.8,26.7z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162.6,53c0,0-3.1-4.1-3.1-6.1c0-2.1,2.5-4.6,2.5-4.6l2.2,7.8L162.6,53L162.6,53z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M167.8,53.3c0,0,0.7-3.3,1.5-5.4c0.8-1.9,0.3-5.6-0.8-6.6c-1.1-1-3.2-0.8-3.2-0.8l0.4,1.5l-3.6,2.3l0.5,9 L167.8,53.3L167.8,53.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M162,44.3c-0.1,0-0.1,0-0.1-0.1c0-0.1,0-0.2,0.1-0.2l4.2-2.6c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.2-0.1,0.2L162,44.3 C162.1,44.3,162.1,44.3,162,44.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M114.7,163.2l2-2.9c0.6-0.9,0.1-2.1-1-2.2l-2.9-0.4c-0.9-0.1-1.7,0.7-1.6,1.6l0.7,4.3L114.7,163.2L114.7,163.2z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M106,150l10.7,2.5l-2.7,11.3l-6.6,1.2l-4.3-1.9L106,150z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M146.9,162l-0.6-3.5c-0.2-1.1,0.8-2,1.9-1.6l2.9,0.9c0.9,0.3,1.3,1.4,0.8,2.2l-2.5,3.7L146.9,162L146.9,162z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M150,152.2l-11.1,1.1l0.1,8.8l6.3,2.7l4.4-2.9L150,152.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M137.7,34.4c-1.1-3.5,1.4-6,4.2-6.9c3.9-1.3,7.4,0.9,6.7,3.4c-0.8,3-3.4,3-6.3,3.4 C138.9,34.7,138.6,37.2,137.7,34.4L137.7,34.4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M146.5,38.4l0,6.1l-7.3,0.4l1.7-8.4L146.5,38.4z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145,38.1l-1,3.4l-4.2-0.7l1.5-4.5L145,38.1z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9,37.6l3.5,2.5l0.6-2l-3.7-1.8L140.9,37.6z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.9,33.3l1.6-0.5l-1.5,2.5L148.9,33.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M138.8,35.3c-0.8-3.1,0.8-6.2,3.7-6.9s5.9-0.4,6.6,4.2c0.5,3.1-0.1,6-3,6.4C142.6,39.4,139.6,38.3,138.8,35.3 L138.8,35.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M135.2,89.3l-12.4,58.3l-19.6-4.4c0,0,11.3-48.4,16.5-60.7c5.2-12.3,9.1-20.6,9.1-20.6l10.2-0.1L135.2,89.3 L135.2,89.3z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 101.8,
    y: 59.6,
    width: 44.2,
    height: 96.2
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 101.8,
    y: 59.6,
    width: 44.2,
    height: 96.2,
    id: "mask9_262_14984_00000111899603717126353900000005816642142716618624_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M135.2,89.3l-12.4,58.3l-19.6-4.4c0,0,11.3-48.4,16.5-60.7c5.2-12.3,9.1-20.6,9.1-20.6l10.2-0.1L135.2,89.3 L135.2,89.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.1,155.8C102.1,155.8,102.1,155.8,102.1,155.8c-0.2-0.1-0.3-0.2-0.3-0.4l26.7-93.6c0-0.2,0.2-0.3,0.4-0.2 c0.2,0,0.3,0.2,0.2,0.4l-26.7,93.6C102.4,155.7,102.3,155.8,102.1,155.8L102.1,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.8,155.1C107.7,155.1,107.7,155.1,107.8,155.1c-0.2-0.1-0.3-0.2-0.3-0.4l26.7-93.6c0-0.2,0.2-0.3,0.4-0.2 c0.2,0,0.3,0.2,0.2,0.4l-26.7,93.6C108,155,107.9,155.1,107.8,155.1L107.8,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.4,154.4C113.4,154.4,113.4,154.4,113.4,154.4c-0.2-0.1-0.3-0.2-0.3-0.4l26.7-93.6c0-0.2,0.2-0.3,0.4-0.2 c0.2,0,0.3,0.2,0.2,0.4l-26.7,93.6C113.7,154.4,113.6,154.4,113.4,154.4L113.4,154.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.1,153.8C119.1,153.8,119,153.8,119.1,153.8c-0.2-0.1-0.3-0.2-0.3-0.4l26.7-93.6c0-0.2,0.2-0.3,0.4-0.2 c0.2,0,0.3,0.2,0.2,0.4l-26.7,93.6C119.3,153.7,119.2,153.8,119.1,153.8L119.1,153.8z"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M145.5,67.2c0,0,4.4,13.2,6.7,30.8c2.4,17.6,0.8,49.3,0.8,49.3l-18.3,0.3l-2.5-56.6l-4-1.8l3.9-25.6L145.5,67.2 L145.5,67.2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M129,82.2C129,82.2,129,82.2,129,82.2c-0.1,0-0.2-0.1-0.1-0.2l3.5-15.7c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0.1,0.2 l-3.5,15.7C129.1,82.1,129,82.2,129,82.2z"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000088107429189222565970000017981163078215795381_",
    filterUnits: "userSpaceOnUse",
    x: 127.8,
    y: 59.3,
    width: 22.7,
    height: 104.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 127.8,
    y: 59.3,
    width: 22.7,
    height: 104.4,
    id: "mask10_262_14984_00000110428264738177317060000006806328223622678923_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      filter: "url(#Adobe_OpacityMaskFilter_00000088107429189222565970000017981163078215795381_)"
    },
    d: " M145.5,67.2c0,0,4.4,13.2,6.7,30.8c2.4,17.6,0.8,49.3,0.8,49.3l-18.3,0.3l-2.5-56.6l-4-1.8l2.4-26.4L145.5,67.2L145.5,67.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.9,163.7c-0.2,0-0.3-0.1-0.3-0.3l0.5-97.3c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3l-0.5,97.3 C134.2,163.5,134,163.7,133.9,163.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.1,162.6c-0.2,0-0.3-0.1-0.3-0.3l0.5-97.3c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3l-0.5,97.3 C128.4,162.5,128.2,162.6,128.1,162.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.1,161.5c-0.2,0-0.3-0.1-0.3-0.3l0.5-97.3c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3l-0.5,97.3 C139.4,161.4,139.3,161.5,139.1,161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.4,159.4c-0.2,0-0.3-0.1-0.3-0.3l0.5-97.3c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3l-0.5,97.3 C144.7,159.2,144.6,159.4,144.4,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M149.7,157.2c-0.2,0-0.3-0.1-0.3-0.3l0.5-97.3c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3l-0.5,97.3 C150,157.1,149.8,157.2,149.7,157.2z"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M148.3,147.1c-0.1,0-0.2-0.1-0.2-0.2c0-0.3,0.1-33.4-0.5-44.5c-0.6-11.1-4.9-37.4-4.9-37.6c0-0.1,0-0.2,0.1-0.2 c0.1,0,0.2,0,0.2,0.1c0,0.3,4.4,26.6,4.9,37.7c0.6,11.1,0.5,44.2,0.5,44.5C148.4,147,148.4,147.1,148.3,147.1z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M148.3,66.8c0,0,8.4,12.9,16.4,10.1c10.1-3.5,6.3-24.6,6.3-24.6l-10.5,0.1l-0.4,4.9c0,0-7-9.2-10.5-12.1 c-3.5-3-10.3-3.4-13.4-3.7c-3.1-0.2-5.6-3-13.8,7.7c-8.2,10.7-23,33.1-23,33.1l9.6,7.5l16.7-24.7l0.1,1.5l22.3,2.9L148.3,66.8 L148.3,66.8z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M164.8,63.9c0,0-0.1,0-0.1-0.1l-5.7-7.4c-0.1-0.1,0-0.2,0-0.2c0.1-0.1,0.2,0,0.2,0l5.7,7.4 C164.9,63.7,164.9,63.8,164.8,63.9C164.8,63.9,164.8,63.9,164.8,63.9L164.8,63.9z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M125.7,65.2C125.7,65.2,125.7,65.2,125.7,65.2c-0.1,0-0.2-0.1-0.2-0.2c0.2-4.8,1.9-16.4,1.9-16.5c0-0.1,0.1-0.1,0.2-0.1 c0.1,0,0.1,0.1,0.1,0.2c0,0.1-1.7,11.7-1.9,16.5C125.8,65.1,125.7,65.2,125.7,65.2L125.7,65.2z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M145.5,54.1C145.5,54.1,145.5,54.1,145.5,54.1c-0.1,0-0.2-0.1-0.2-0.2c0.8-6.9,4.5-8.1,4.6-8.1c0.1,0,0.2,0,0.2,0.1 c0,0.1,0,0.2-0.1,0.2c0,0-3.7,1.2-4.4,7.9C145.7,54,145.6,54.1,145.5,54.1L145.5,54.1z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M148.5,67.3c0,0-0.1,0-0.1-0.1l-3.7-4.9c-0.1-0.1,0-0.2,0-0.2c0.1-0.1,0.2,0,0.2,0l3.7,4.9 C148.6,67.1,148.6,67.2,148.5,67.3C148.5,67.2,148.5,67.3,148.5,67.3L148.5,67.3z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M160.2,55.3c-0.1,0-0.2-0.1-0.2-0.1c0-0.1,0.1-0.2,0.2-0.2l11.1-0.1c0.1,0,0.2,0.1,0.2,0.1c0,0.1-0.1,0.2-0.2,0.2 L160.2,55.3L160.2,55.3z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M109.9,87.6C109.9,87.6,109.8,87.6,109.9,87.6l-9-7.1c-0.1-0.1-0.1-0.1,0-0.2c0.1-0.1,0.2-0.1,0.2,0l9,7 c0.1,0.1,0.1,0.1,0,0.2C110,87.6,109.9,87.6,109.9,87.6z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M145.3,44.6l-0.9-3.9l-4.8-1.4l-2.1,2.4L145.3,44.6z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M145.5,31.1c0,0-0.1,0-0.1-0.1c0-0.1,0-0.2,0-0.2c1.3-0.9,2.4-0.4,2.5-0.4c0.1,0,0.1,0.1,0.1,0.2c0,0.1-0.1,0.1-0.2,0.1 C147.7,30.8,146.7,30.3,145.5,31.1C145.5,31.1,145.5,31.1,145.5,31.1L145.5,31.1z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M134.3,29c-0.9-1-0.9-2.5,0-3.2c0.9-0.8,2.3-0.6,3.2,0.5c0.9,1,0.9,2.5,0,3.2C136.6,30.2,135.2,30,134.3,29z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M144.8,29.1c1.5,0,2.8,0.4,3.6,0.9c-1.2-2.5-3.9-2.4-6-1.8c-2.9,0.8-4.6,3.9-3.7,7.1c0.1,0.4,0.3,0.8,0.5,1.2 l0.4,0.3l1.3-3.8C144.1,32.1,144.8,29.1,144.8,29.1L144.8,29.1z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M137.5,33.5c0,0,0.8,2.8,0.4,5.8c-0.3,3-4.3,9.3-4.3,9.3l2.6,0.3l2.4-2.3l-1.1,2.5l1.7,0.2 c0,0,4.1-6.7,2.3-13.2L137.5,33.5L137.5,33.5z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M132.7,101.3c-0.1,0-0.1-0.1-0.2-0.1l-0.4-9.9l-3.9-1.7c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.1,0.2-0.1l4,1.8 c0.1,0,0.1,0.1,0.1,0.1l0.4,10C132.9,101.2,132.8,101.3,132.7,101.3C132.7,101.3,132.7,101.3,132.7,101.3L132.7,101.3z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000053519485950879239530000011141755915117966764_",
    filterUnits: "userSpaceOnUse",
    x: 134.5,
    y: 24.9,
    width: 3,
    height: 5.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 134.5,
    y: 24.9,
    width: 3,
    height: 5.5,
    id: "mask15_262_14984_00000092417709765313343850000001085004822384630681_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      filter: "url(#Adobe_OpacityMaskFilter_00000053519485950879239530000011141755915117966764_)"
    },
    d: " M134.3,29c-0.9-1-0.9-2.5,0-3.2c0.9-0.8,2.3-0.6,3.2,0.5c0.9,1,0.9,2.5,0,3.2C136.6,30.2,135.2,30,134.3,29z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.1,30.4c0,0-0.1,0-0.1-0.1c0-0.1,0-0.2,0-0.2c2.8-1.8,2.1-5,2.1-5c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.2,0.1 C137.4,25.1,138.1,28.5,135.1,30.4C135.1,30.4,135.1,30.4,135.1,30.4L135.1,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.6,28.9c-0.1,0-0.1,0-0.1-0.1l-2-3.6c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.2,0.1l2,3.6C136.8,28.7,136.7,28.8,136.6,28.9 C136.6,28.9,136.6,28.9,136.6,28.9z"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M148.1,35.8c0,0-1.6-0.9-2-0.2c-0.4,0.6,1.1,1.3,1.8,1.2C148.5,36.6,148.5,36.1,148.1,35.8z"
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000046316361975960697320000000943899454837206938_",
    filterUnits: "userSpaceOnUse",
    x: 145.1,
    y: 35.6,
    width: 6,
    height: 2.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 145.1,
    y: 35.6,
    width: 6,
    height: 2.4,
    id: "mask16_262_14984_00000010992274775506275570000013535375693062255016_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      filter: "url(#Adobe_OpacityMaskFilter_00000046316361975960697320000000943899454837206938_)"
    },
    d: " M148.1,35.8c0,0-1.6-0.9-2-0.2c-0.4,0.6,1.1,1.3,1.8,1.2C148.5,36.6,148.5,36.1,148.1,35.8z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M148.5,35.6c0,0-1.1-0.1-2.9,0.7c-1.8,0.8,2,1.6,2,1.6l3.5-0.4L148.5,35.6L148.5,35.6z"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.6,33.1c0,0-1.1-2.1-3.7-0.8C144.9,32.3,146.7,34.9,148.6,33.1z"
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000008117273485786262700000001270406250212982460_",
    filterUnits: "userSpaceOnUse",
    x: 146.5,
    y: 31.6,
    width: 2.2,
    height: 2.2
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 146.5,
    y: 31.6,
    width: 2.2,
    height: 2.2,
    id: "mask17_262_14984_00000171000764445846093630000001215532870712825761_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      filter: "url(#Adobe_OpacityMaskFilter_00000008117273485786262700000001270406250212982460_)"
    },
    d: " M148.6,33.1c0,0-1.1-2.1-3.7-0.8C144.9,32.3,146.7,34.9,148.6,33.1z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.7,32.7c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1C148.2,31.6,148.7,32.1,148.7,32.7z"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M139.5,33.4c-0.6,0-1.3-0.1-2.1-0.4c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c3,1.1,4.9-0.4,5.7-1.3 c-0.9,0.3-2.9,0.6-5.3-0.9c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c3.2,1.9,5.6,0.6,5.6,0.6c0.1,0,0.1,0,0.2,0 c0,0.1,0.1,0.1,0,0.2C143.8,31.2,142.2,33.4,139.5,33.4L139.5,33.4z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M142.5,33.4c-0.5-0.9-1.6-1.2-2.3-0.8c-0.8,0.5-1,1.5-0.5,2.4c0.5,0.9,1.6,1.2,2.3,0.8 C142.8,35.4,143,34.3,142.5,33.4z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M141.7,34.7C141.7,34.7,141.6,34.7,141.7,34.7l-1.5-1c-0.1,0-0.1-0.1,0-0.2s0.1-0.1,0.2,0l1.4,1c0.1,0,0.1,0.1,0,0.2 C141.8,34.7,141.7,34.7,141.7,34.7z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M140.7,35.1C140.6,35.1,140.6,35.1,140.7,35.1c-0.2-0.1-0.2-0.2-0.1-0.2l0.5-0.6c0.1-0.1,0.2-0.1,0.2,0 c0.1,0.1,0.1,0.1,0,0.2l-0.5,0.6C140.8,35.1,140.7,35.1,140.7,35.1z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M139.1,160.6l-2.5,12l28.2,0.1l0.1-3.8c0-2.6-1.8-4.9-4.4-5.4l-10.9-2.3l-6.5,1.8L139.1,160.6z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M164.9,169.9h-27.5c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2h27.5c0.1,0,0.2,0.1,0.2,0.2 C165,169.9,164.9,169.9,164.9,169.9z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M154.7,163.4c-0.1,0-0.1-0.1-0.2-0.1l-0.1-1.4l-2.6,0.6c-0.1,0-0.1,0-0.1,0c0,0-0.1-0.1,0-0.1l0.3-1.7 c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0.1,0.2l-0.3,1.5l2.5-0.6c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1l0.1,1.6 C154.9,163.3,154.8,163.4,154.7,163.4C154.7,163.4,154.7,163.4,154.7,163.4L154.7,163.4z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M103,162l-2.6,10.7h22.7l0.2-3c0.3-3.8-2.5-6.7-6.2-7.3l-2.7-0.5l-4.2,1.7l-3.1-2.6c-1.1-0.9-2.7-0.7-3.6,0.3 L103,162L103,162z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M123.4,170.2h-21.8c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2h21.8c0.1,0,0.2,0.1,0.2,0.2 C123.5,170.1,123.5,170.2,123.4,170.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningInfoGroup);
export default __webpack_public_path__ + "static/media/warning-info-group.d56c1601.svg";
export { ForwardRef as ReactComponent };